import { defineMessages } from 'utils/intl';

export default defineMessages({
  here: '{shop} - Tutaj jesteś',
  bold: 'od {year} roku',
  bigBold: 'Od {year} roku',
  biznesowe: `
    Nasz najmłodszy sklep online działający {bold}. Zapewniamy firmom i instytucjom dostęp do sprawdzonych rozwiązań IT renomowanych producentów.
    Znajdziesz tu podstawowe wyposażenie IT dla każdej firmy – legalny sprzęt z polskiej dystrybucji, objęty
    wsparciem technicznym i pełną gwarancją producenta – HP, HPE, Dell, Fujitsu, Lenovo, Fortinet i wielu innych.
  `,
  dellowo: `
    Nasz pierwszy e-commerce działający {bold} to Dellowo.pl. Sklep przeznaczony jest wyłącznie dla firm i instytucji.
    Specjalizujemy się w rozwiązaniach Dell takich jak laptopy, komputery, stacje robocze i serwery.
    99,7% zamówień realizujemy z dostawą poniżej 24h!
  `,
  premiumStation: `
    Stacje robocze i mobilne stacje robocze to domena naszych ekspertów z premiumstation.pl.
    To właśnie tam dobierzesz sprzęt odpowiedni do swoich potrzeb.
    Możesz skorzystać z gotowych rozwiązań lub dokonać indywidualnej konfiguracji stacji roboczej z pomocą naszego doradcy.
    {bold} dostarczamy firmom i instytucjom komputery oraz laptopy o dużej moc obliczeniowej. 
  `,
  premiumServer: `
  Obsługujemy zapytania ofertowe i przetargi na serwery, macierze, rozwiązania backupowe, biblioteki taśmowe, urządzenia sieciowe oraz bezpieczeństwa infrastruktury IT.
  Dotychczas skonfigurowaliśmy i dostarczyliśmy tysiące serwerów dla klientów B2B i instytucji publicznych.
  Stale poszerzamy swoją wiedzę o coraz nowsze technologie, chcąc zapewnić najbardziej optymalne rozwiązanie do potrzeb klienta.
`,
  cocon: `
    Pod nazwą COCON działamy {bold}. To my tworzymy marki takie jak premiumserwer.pl, dellowo.pl, premiumstation.pl, biznesowe.pl oraz firewall.pl.
    W ramach Cocon zajmujemy się jednak czymś więcej!
    Świadczymy usługi integratorskie: projektowanie, zarzadzanie i utrzymywanie środowisk IT w tym środowisk fizycznych, wirtualnych i backupowych, tworzymy, wdrażamy i zapewniamy bezpieczeństwo sieci.
    Świadczymy doradztwo informatyczne oraz outsourcing IT realizowane przez wykwalifikowany zespół inżynierów.
  `,
  firewall: `
    Najnowszy z naszych sklepów internetowych powstał w odpowiedzi na stale rosnący problem cyberzagrożeń.
    W oparciu o naszą wiedzę i doświadczenie z zakresu bezpieczeństwa sieci oferujemy sprawdzone rozwiązania znanych producentów obszaru security.
  `,
});
